import { FetchContext } from '../fetch-context';
import { EmailTemplateRequest } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const updateEmailTemplate: (
  fetchContext: FetchContext,
  programId: number,
  emailTemplateId: number,
  emailTemplate: EmailTemplateRequest,
  isForSending: boolean,
  accessToken?: string,
) => Promise<number> = (fetchContext, programId, emailTemplateId, emailTemplate, isForSending, accessToken) => {
  const params = new URLSearchParams();
  params.append('isForSending', `${isForSending}`);

  const url = `${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/${emailTemplateId}${params.size > 0 ? `?${params}` : ''}`;

  return fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(emailTemplate),
  }).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'update email template'));
};
